module.exports = __webpack_public_path__ + "img/abtus.1e209456.jpg";